import { useEffect, useState } from "react";
type SSOLink = { name: string; href: string };

export function useSSOLinks(urlSSO = "") {
	const [ssoLinks, setSSOLinks] = useState<SSOLink[]>([{ name: 'Iniciar sesión', href: `${urlSSO}` }]);
	useEffect(() => {
		if (typeof window === 'undefined') return;

		const currentPage = new URL(window.location.href);
		const urlWithoutParams = `${currentPage.origin}${currentPage.pathname}`;
		const base64Url = Buffer.from(urlWithoutParams).toString('base64');

		setSSOLinks([
			{ name: 'Iniciar sesión', href: `${urlSSO}?url=${base64Url}` },
		]);
	}, [urlSSO]);

	return ssoLinks;
}